var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVoid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "360px",
    height: "360px",
    viewBox: "0 0 360 360",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Illustration / Empty State / Void-New") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "99.9079444%",
    y1: "0%",
    x2: "1.7621146%",
    y2: "98.3268605%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8369",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D571B5",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration-/-Empty-State-/-Void-New",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration-holder-01",
    transform: "translate(2.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "undraw_void_3ggu-(1)",
    transform: "translate(0.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#33333F",
    fillRule: "nonzero",
    opacity: 0.1,
    cx: 131.259953,
    cy: 331.5,
    rx: 131.259953,
    ry: 19.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#3F3D56",
    fillRule: "nonzero",
    cx: 210.499833,
    cy: 128.959184,
    rx: 128.23553,
    ry: 128.959184
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.05,
    cx: 211.104717,
    cy: 128.959184,
    rx: 105.854801,
    ry: 105.952381
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.05,
    cx: 211.104717,
    cy: 128.959184,
    rx: 86.4984945,
    ry: 86.5782313
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.05,
    cx: 209.894948,
    cy: 127.748299,
    rx: 62.3031114,
    ry: 62.3605442
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8423135,139.251701 C83.8423135,139.251701 74.2562951,168.157687 78.5167459,178.426917 C82.7771968,188.696148 89.5229174,198.585034 89.5229174,198.585034 C89.5229174,198.585034 87.0376517,141.153411 83.8423135,139.251701 Z",
    id: "Path",
    fill: "#D0CDE1",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8423135,139.251701 C83.8423135,139.251701 74.2562951,168.157687 78.5167459,178.426917 C82.7771968,188.696148 89.5229174,198.585034 89.5229174,198.585034 C89.5229174,198.585034 87.0376517,141.153411 83.8423135,139.251701 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.7543257,205.391678 C89.7543257,205.391678 89.0043927,212.537896 88.6294284,212.914011 C88.254464,213.290127 89.0043927,214.042361 88.6294284,215.170711 C88.254464,216.299061 87.8794954,217.80353 88.6294284,218.179646 C89.3793614,218.555761 84.5048034,251.654039 84.5048034,251.654039 C84.5048034,251.654039 72.5058926,267.450946 77.3804507,292.274651 L78.8803124,317.474476 C78.8803124,317.474476 90.5042587,318.226711 90.5042587,314.089423 C90.5042587,314.089423 89.7543257,309.199908 89.7543257,306.943204 C89.7543257,304.6865 91.6291561,304.686504 90.5042587,303.558154 C89.3793614,302.429804 89.3793614,301.67757 89.3793614,301.67757 C89.3793614,301.67757 91.2541874,300.173105 90.8792231,299.796985 C90.5042587,299.420866 94.2539151,272.71658 94.2539151,272.71658 C94.2539151,272.71658 98.3785401,268.579296 98.3785401,266.322592 L98.3785401,264.065892 C98.3785401,264.065892 100.25337,259.176377 100.25337,258.800258 C100.25337,258.424138 110.377451,235.481017 110.377451,235.481017 L114.502076,252.030154 L119.00167,275.725514 C119.00167,275.725514 121.251464,297.16417 125.751054,305.438752 C125.751054,305.438752 133.625339,332.519161 133.625339,331.766927 C133.625339,331.014692 146.749147,329.134107 146.374183,325.749058 C145.999219,322.364008 138.499897,274.973293 138.499897,274.973293 L140.374728,204.639456 L89.7543257,205.391678 Z",
    id: "Path",
    fill: "#2F2E41",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6066985,315.677354 C80.6066985,315.677354 70.6493446,335.464378 77.287582,336.211037 C83.9258193,336.957696 86.5073531,336.957718 89.4576803,333.971 C91.0706212,332.338164 94.3369306,330.147405 96.9667389,328.496781 C100.146377,326.533226 101.936478,322.901613 101.574476,319.148975 C101.379983,317.322381 100.705801,315.817356 99.0462408,315.677354 C94.620752,315.304016 89.4576845,311.197279 89.4576845,311.197279 L80.6066985,315.677354 Z",
    id: "Path",
    fill: "#2F2E41",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.25608,330.207965 C136.25608,330.207965 126.298726,349.994985 132.936963,350.741648 C139.5752,351.488312 142.156734,351.488325 145.107061,348.501612 C146.720002,346.868772 149.986312,344.678018 152.61612,343.027394 C155.795758,341.06384 157.585859,337.432227 157.223857,333.67959 C157.029364,331.852997 156.355182,330.347971 154.695626,330.207965 C150.270133,329.834627 145.10707,325.727891 145.10707,325.727891 L136.25608,330.207965 Z",
    id: "Path",
    fill: "#2F2E41",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFB8B8",
    fillRule: "nonzero",
    cx: 125.815992,
    cy: 92.0272109,
    rx: 15.726999,
    ry: 15.7414966
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.031989,98.0816327 C116.031989,98.0816327 104.953882,118.170402 104.067649,118.170402 C103.181417,118.170402 124.008216,124.721088 124.008216,124.721088 C124.008216,124.721088 129.768824,105.505742 130.655069,103.758893 L116.031989,98.0816327 Z",
    id: "Path",
    fill: "#FFB8B8",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.272591,119.676226 C132.272591,119.676226 110.048596,107.405142 107.826185,107.776991 C105.603774,108.148841 81.8981948,128.972505 82.2685973,137.525077 C82.6389998,146.07765 85.6021946,160.207994 85.6021946,160.207994 C85.6021946,160.207994 86.7133938,199.624205 88.935792,199.996055 C91.1581902,200.367904 88.5653937,207.061224 89.3061945,207.061224 C90.0469953,207.061224 141.162171,207.061224 141.532574,205.945672 C141.902976,204.830119 132.272591,119.676226 132.272591,119.676226 Z",
    id: "Path",
    fill: "#D0CDE1",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.318222,208.272109 C145.318222,208.272109 152.352535,230.826091 146.428903,230.048366 C140.50527,229.270642 137.913684,210.605278 137.913684,210.605278 L145.318222,208.272109 Z",
    id: "Path",
    fill: "#FFB8B8",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.343287,117.494282 C125.343287,117.494282 111.75674,120.505979 113.959967,139.32908 C116.163194,158.152181 120.202433,176.975286 120.202433,176.975286 L133.788979,207.468713 L135.257793,213.115646 L145.172298,210.48041 L137.828222,166.81081 C137.828222,166.81081 135.257793,120.129518 131.952959,118.623668 C129.868936,117.712817 127.602806,117.325607 125.343287,117.494282 Z",
    id: "Path",
    fill: "#D0CDE1",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1,
    points: "117.347608 176.03443 134.284376 207.061224 120.014882 174.367347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.252992,87.0429493 L141.304999,85.8344697 L143.696497,86.4328216 C143.644641,85.6476542 143.252971,84.9248096 142.624903,84.4551431 L145.172298,84.3119615 C140.852812,78.1415403 134.210959,74.0152785 126.788994,72.8913038 C121.278913,72.0884875 115.143597,73.2502155 111.365169,77.3609669 C109.532461,79.3548734 108.380892,81.8905071 107.561722,84.4773448 C106.052991,89.2417272 105.745588,94.9212069 108.891576,98.7939536 C112.088966,102.729971 117.673889,103.500991 122.705717,103.988112 C124.476196,104.15952 126.331612,104.318999 127.972278,103.628463 C128.154885,101.736718 127.913986,99.8278716 127.267246,98.0418913 C126.997926,97.4890169 126.869213,96.8776287 126.892632,96.2624765 C127.116303,94.7576663 129.11308,94.3785498 130.613081,94.5818614 C132.113082,94.785173 133.916717,95.096219 134.902355,93.9415145 C135.58126,93.1461416 135.541215,91.9878889 135.631161,90.9436912 C135.876044,88.101031 141.22736,87.6388844 141.252992,87.0429493 Z",
    id: "Path",
    fill: "#00CACF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#2F94FB",
    fillRule: "nonzero",
    cx: 237.114754,
    cy: 317.251701,
    rx: 18.1465373,
    ry: 18.1632653
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#2F94FB",
    fillRule: "nonzero",
    cx: 22.9856139,
    cy: 311.197279,
    rx: 18.1465373,
    ry: 18.1632653
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#2F94FB",
    fillRule: "nonzero",
    cx: 23.5904985,
    cy: 285.768707,
    rx: 12.7025761,
    ry: 13.3197279
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "url(#linearGradient-1)",
    cx: 22.9856139,
    cy: 266.394558,
    rx: 9.67815323,
    ry: 9.68707483
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoid);
export default __webpack_public_path__ + "static/media/void.f021883aae7d588db27d4d8cb46f5449.svg";
export { ForwardRef as ReactComponent };